import { ChainEnv } from '@vertex-protocol/client';
import {
  ABSTRACT_PERP_METADATA_BY_PRODUCT_ID,
  ABSTRACT_SPOT_METADATA_BY_PRODUCT_ID,
  ABSTRACT_TESTNET_PERP_METADATA_BY_PRODUCT_ID,
  ABSTRACT_TESTNET_SPOT_METADATA_BY_PRODUCT_ID,
} from './abstract';
import {
  ARB_PERP_METADATA_BY_PRODUCT_ID,
  ARB_SPOT_METADATA_BY_PRODUCT_ID,
  ARB_TESTNET_PERP_METADATA_BY_PRODUCT_ID,
  ARB_TESTNET_SPOT_METADATA_BY_PRODUCT_ID,
} from './arbitrum';
import {
  AVAX_PERP_METADATA_BY_PRODUCT_ID,
  AVAX_SPOT_METADATA_BY_PRODUCT_ID,
  AVAX_TESTNET_PERP_METADATA_BY_PRODUCT_ID,
  AVAX_TESTNET_SPOT_METADATA_BY_PRODUCT_ID,
} from './avax';
import {
  BASE_PERP_METADATA_BY_PRODUCT_ID,
  BASE_SPOT_METADATA_BY_PRODUCT_ID,
  BASE_TESTNET_PERP_METADATA_BY_PRODUCT_ID,
  BASE_TESTNET_SPOT_METADATA_BY_PRODUCT_ID,
} from './base';
import {
  BERACHAIN_PERP_METADATA_BY_PRODUCT_ID,
  BERACHAIN_SPOT_METADATA_BY_PRODUCT_ID,
  BERACHAIN_TESTNET_PERP_METADATA_BY_PRODUCT_ID,
  BERACHAIN_TESTNET_SPOT_METADATA_BY_PRODUCT_ID,
} from './berachain';
import {
  BLAST_PERP_METADATA_BY_PRODUCT_ID,
  BLAST_SPOT_METADATA_BY_PRODUCT_ID,
  BLAST_TESTNET_PERP_METADATA_BY_PRODUCT_ID,
  BLAST_TESTNET_SPOT_METADATA_BY_PRODUCT_ID,
} from './blast';
import {
  INK_PERP_METADATA_BY_PRODUCT_ID,
  INK_SPOT_METADATA_BY_PRODUCT_ID,
  INK_TESTNET_PERP_METADATA_BY_PRODUCT_ID,
  INK_TESTNET_SPOT_METADATA_BY_PRODUCT_ID,
} from './ink';
import {
  HARDHAT_PERP_METADATA_BY_PRODUCT_ID,
  HARDHAT_SPOT_METADATA_BY_PRODUCT_ID,
} from './local';
import {
  MANTLE_PERP_METADATA_BY_PRODUCT_ID,
  MANTLE_SPOT_METADATA_BY_PRODUCT_ID,
  MANTLE_TESTNET_PERP_METADATA_BY_PRODUCT_ID,
  MANTLE_TESTNET_SPOT_METADATA_BY_PRODUCT_ID,
} from './mantle';
import {
  SEI_PERP_METADATA_BY_PRODUCT_ID,
  SEI_SPOT_METADATA_BY_PRODUCT_ID,
  SEI_TESTNET_PERP_METADATA_BY_PRODUCT_ID,
  SEI_TESTNET_SPOT_METADATA_BY_PRODUCT_ID,
} from './sei';
import {
  SONIC_PERP_METADATA_BY_PRODUCT_ID,
  SONIC_SPOT_METADATA_BY_PRODUCT_ID,
  SONIC_TESTNET_PERP_METADATA_BY_PRODUCT_ID,
  SONIC_TESTNET_SPOT_METADATA_BY_PRODUCT_ID,
} from './sonic';
import { PerpProductMetadata, SpotProductMetadata } from './types';

export const SPOT_METADATA_BY_CHAIN_ENV: Record<
  ChainEnv,
  Record<number, SpotProductMetadata>
> = {
  abstract: ABSTRACT_SPOT_METADATA_BY_PRODUCT_ID,
  abstractTestnet: ABSTRACT_TESTNET_SPOT_METADATA_BY_PRODUCT_ID,
  avax: AVAX_SPOT_METADATA_BY_PRODUCT_ID,
  avaxTestnet: AVAX_TESTNET_SPOT_METADATA_BY_PRODUCT_ID,
  arbitrum: ARB_SPOT_METADATA_BY_PRODUCT_ID,
  arbitrumTestnet: ARB_TESTNET_SPOT_METADATA_BY_PRODUCT_ID,
  base: BASE_SPOT_METADATA_BY_PRODUCT_ID,
  baseTestnet: BASE_TESTNET_SPOT_METADATA_BY_PRODUCT_ID,
  bera: BERACHAIN_SPOT_METADATA_BY_PRODUCT_ID,
  beraTestnet: BERACHAIN_TESTNET_SPOT_METADATA_BY_PRODUCT_ID,
  blast: BLAST_SPOT_METADATA_BY_PRODUCT_ID,
  blastTestnet: BLAST_TESTNET_SPOT_METADATA_BY_PRODUCT_ID,
  inkMainnet: INK_SPOT_METADATA_BY_PRODUCT_ID,
  inkTestnet: INK_TESTNET_SPOT_METADATA_BY_PRODUCT_ID,
  local: HARDHAT_SPOT_METADATA_BY_PRODUCT_ID,
  mantle: MANTLE_SPOT_METADATA_BY_PRODUCT_ID,
  mantleTestnet: MANTLE_TESTNET_SPOT_METADATA_BY_PRODUCT_ID,
  sei: SEI_SPOT_METADATA_BY_PRODUCT_ID,
  seiTestnet: SEI_TESTNET_SPOT_METADATA_BY_PRODUCT_ID,
  sonic: SONIC_SPOT_METADATA_BY_PRODUCT_ID,
  sonicTestnet: SONIC_TESTNET_SPOT_METADATA_BY_PRODUCT_ID,
};

export const PERP_METADATA_BY_CHAIN_ENV: Record<
  ChainEnv,
  Record<number, PerpProductMetadata>
> = {
  abstract: ABSTRACT_PERP_METADATA_BY_PRODUCT_ID,
  abstractTestnet: ABSTRACT_TESTNET_PERP_METADATA_BY_PRODUCT_ID,
  avax: AVAX_PERP_METADATA_BY_PRODUCT_ID,
  avaxTestnet: AVAX_TESTNET_PERP_METADATA_BY_PRODUCT_ID,
  arbitrum: ARB_PERP_METADATA_BY_PRODUCT_ID,
  arbitrumTestnet: ARB_TESTNET_PERP_METADATA_BY_PRODUCT_ID,
  base: BASE_PERP_METADATA_BY_PRODUCT_ID,
  baseTestnet: BASE_TESTNET_PERP_METADATA_BY_PRODUCT_ID,
  bera: BERACHAIN_PERP_METADATA_BY_PRODUCT_ID,
  beraTestnet: BERACHAIN_TESTNET_PERP_METADATA_BY_PRODUCT_ID,
  blast: BLAST_PERP_METADATA_BY_PRODUCT_ID,
  blastTestnet: BLAST_TESTNET_PERP_METADATA_BY_PRODUCT_ID,
  inkMainnet: INK_PERP_METADATA_BY_PRODUCT_ID,
  inkTestnet: INK_TESTNET_PERP_METADATA_BY_PRODUCT_ID,
  local: HARDHAT_PERP_METADATA_BY_PRODUCT_ID,
  mantle: MANTLE_PERP_METADATA_BY_PRODUCT_ID,
  mantleTestnet: MANTLE_TESTNET_PERP_METADATA_BY_PRODUCT_ID,
  sei: SEI_PERP_METADATA_BY_PRODUCT_ID,
  seiTestnet: SEI_TESTNET_PERP_METADATA_BY_PRODUCT_ID,
  sonic: SONIC_PERP_METADATA_BY_PRODUCT_ID,
  sonicTestnet: SONIC_TESTNET_PERP_METADATA_BY_PRODUCT_ID,
};
